function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 18.2637L5.5 18.2637M1.5 6.26367L5.5 6.26367M1.5 12.2637L5.5 12.2637M3.5 22.2637L3.5 2.26366C3.5 1.71138 3.94771 1.26366 4.5 1.26366L22.5 1.26366C23.0523 1.26366 23.5 1.71137 23.5 2.26366L23.5 22.2637C23.5 22.816 23.0523 23.2637 22.5 23.2637L4.5 23.2637C3.94772 23.2637 3.5 22.816 3.5 22.2637ZM15.533 8.61215C15.533 9.53933 14.7517 10.291 13.7879 10.291C12.824 10.291 12.0427 9.53933 12.0427 8.61215C12.0427 7.68496 12.824 6.93333 13.7879 6.93333C14.7517 6.93333 15.533 7.68496 15.533 8.61215ZM9.78784 17.1611C10.5342 14.4561 12.0427 12.5333 13.7878 12.5333C15.533 12.5333 17.0415 14.4561 17.7878 17.1611C14.4181 18.89 11.0505 17.8815 9.78784 17.1611Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgAgenda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenda);
export default __webpack_public_path__ + "static/media/agenda.f5f2d40b.svg";
export { ForwardRef as ReactComponent };